import React from 'react';

import _ from 'lodash';

import AgentStatus from '../../components/AgentStatus';
import DriverProperty from '../../components/DriverProperty';
import SidebarPanel from '../../components/SidebarPanel';
import BOBDate from '../../components/BOBDate';

import classes from './AgentInformationPanel.module.css';

const AgentInformationPanel = ({agent}) => (
    <SidebarPanel
        title="Agent Information"
        titleIconSrc="/assets/images/basAgentIconColor.svg"
    >
        <dl className={classes.agentInfo}>
            <dt>Serial Number</dt>
            <dd>{agent.serialNumber}</dd>

            <dt>Connection Status</dt>
            <dd><AgentStatus agent={agent} showLabel /></dd>

            <dt>Firmware</dt>
            <dd>{agent.firmwareVersion}</dd>

            <dt>Agent IP Address</dt>
            <dd>{agent.externalAgentIpAddress ? agent.externalAgentIpAddress : ''}</dd>

            <dt>Deployment</dt>
            <dd>{agent.deployment}</dd>

            <dt>BAS Driver</dt>
            <dd>
                <DriverProperty
                    config={agent.driverConfiguration}
                    property="basType"
                />
            </dd>

            <dt>Average BAS Load</dt>
            <dd>
                <DriverProperty
                    config={agent.driverConfiguration}
                    format="percent"
                    property="currentLoad"
                />
            </dd>

            <dt>Time Zone</dt>
            <dd>{agent.timeZone}</dd>

            <BOBDate
                date={_.get(agent, 'actions.inventoryScan.timeCompleted')}
                render={date => (
                    <>
                        <dt>Latest Inventory Date</dt>
                        <dd>{date}</dd>
                    </>
                )}
            />
            <BOBDate
                date={_.get(agent, 'actions.poll.timeCompleted')}
                render={date => (
                    <>
                        <dt>Latest Poll Date</dt>
                        <dd>{date}</dd>
                    </>
                )}
            />
            <dt>Total Points Polled</dt>
            <dd>{agent.sensorCount}</dd>
        </dl>
    </SidebarPanel>
);

export default AgentInformationPanel;
